import client from "../libs/HttpClient";

class BlogServices {
  static blogList(request) {
    const page_no = request.queryKey[1];
    return client.get(`/blog?page=${page_no}`, request);
  }
  static addBlog(request) {
    return client.post(`/add-blog`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static updateBlog(request) {
    return client.post(`/edit-blog`, request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  static viewBlog(params) {
    return client.get(`get-blog`, { params });
  }
  static deleteBlog(params) {
    return client.delete(`delete-blog`, { params });
  }
}
export { BlogServices };
